<template>
  <div class="pay">
    <van-nav-bar
      title="通讯录"
      left-text="返回"
      right-text="添加"
      left-arrow
      @click-left="$router.go('-1')"
      @click-right="handleAdd"
    />
    <!-- <van-notice-bar
      wrapable
      :scrollable="false"
      text="由于设备网络连接等因素，5分钟内号码才会同步生效！"
    /> -->
    <van-cell-group class="c-margin-top-normal">
      <!-- <van-field
        v-model="studnetInfo.phone1"
        label="亲情号1"
        right-icon="ellipsis"
        placeholder="手机号"
      /> -->
      
        <van-swipe-cell
          v-for="(item, index) in phoneList"
          :key="index"
          style="margin-top: 10px;position:relative;"
        >
          <van-cell :border="false" :title="item.Name+': '+item.Phone"> </van-cell>
          <div style="position: absolute;top: 0;right:0;">
            <van-button square type="danger" text="删除" @click="deletePhone(item)" />
          </div>
        </van-swipe-cell>
      
    </van-cell-group>
    
    <!-- 查找位置弹出层 -->
    <van-dialog
      v-model="showaddPhoneDialog"
      title="添加号码"
      show-cancel-button
      @confirm="handleAddPhone"
    >
    <input
      class="dialog-input"
      v-model="callName"
      type="text"
      placeholder="称呼(爸爸,妈妈...)"
    />
    <input
      class="dialog-input"
      v-model="addPhone"
      type="text"
      placeholder="号码"
    />
    </van-dialog>
  </div>
</template>

<script>
import { NavBar, NoticeBar, Empty,PullRefresh, List, CellGroup,Dialog,SwipeCell, Cell, Field, Button, Toast } from 'vant'
import CCard from '@/components/c-card.vue'

export default {
  data() {
    return {
      callName:"",
      addPhone:"",
      showaddPhoneDialog:false,
      studentInfo: {},
      phoneList:[]
    }
  },
  computed: {
    
  },
  created() {
    this.getDeviceAddressbook()
  },
  methods: {
    // 获取学生信息
    getDeviceAddressbook:function() {
      var sinfo = localStorage.getItem("currentChild");
      this.studentInfo = JSON.parse(sinfo);
      if(this.studentInfo.Deviceid==""){
        Toast("小孩未绑定设备")
        this.$router.push("/my");
        return;
      }
    
      this.$http
        .json_post(this.$api.studentcard.getaddressbook, {
          Deviceid: this.studentInfo.Deviceid
        })
        .then(data => {
        
          if (data.code == 0) {
            this.phoneList=data.data;
          }else{
            Toast(data.msg)
          }
        })
    },
    handleAdd:function(){
      this.callName=""
      this.addPhone=""
      this.showaddPhoneDialog =true;

    },
    handleAddPhone:function(){
      if (this.callName==""){
        Toast("请填写称呼")
        return
      }
      if (this.addPhone==""){
        Toast("请填写号码")
        return
      }
      
      var max =0;
      if (this.phoneList !=null) {
        for(var i=0;i<this.phoneList.length;i++){
          if(i==0){
            max=eval(this.phoneList[i].ID);
            continue
          }
          if (max<eval(this.phoneList[i].ID)){
            max=eval(this.phoneList[i].ID)
          }
        }
      }
      max=eval(max)+1
      this.$http
        .json_post(this.$api.studentcard.addfamilyphone, {
          Deviceid: this.studentInfo.Deviceid,
          Phone: {
            ID:max+"",
            Name:this.callName,
            Phone:this.addPhone
          }
        })
        .then(data => {
          if (data.code == 0) {
            Toast("添加成功")
            this.showaddPhoneDialog=false;
            this.getDeviceAddressbook();
          }else{
            Toast(data.msg)
          }
        })
    },
    deletePhone:function(data){
      
      this.$http
        .json_post(this.$api.studentcard.delfamilyphone, {
          Deviceid: this.studentInfo.Deviceid,
          Phone: {
            ID:data.ID,
            Name:data.Name,
            Phone:data.Phone
          }
        })
        .then(data => {
          if (data.code == 0) {
            Toast("删除成功")
            this.getDeviceAddressbook();
          }else{
            Toast(data.msg)
          }
        })
    },
  },
  components: {
    'van-nav-bar': NavBar,
    'van-notice-bar': NoticeBar,
    'van-cell-group': CellGroup,
    'van-field': Field,
    'van-button': Button,
    'c-card': CCard,
    'van-list': List,
    'van-pull-refresh': PullRefresh,
    'van-swipe-cell': SwipeCell,
    'van-cell': Cell
  }
}
  
</script>

<style lang="scss" scoped>
.pay-row-item {
  line-height: 20px;
  .pay-row-item__title {
    display: inline-block;
    width: 70px;
    color: $text-secondary-color;
  }
}
.dialog-input {
  display: block;
  width: 275px;

  height: 0.8rem;
  line-height: 17px;
  font-size: 15px;
  font-weight: 500;
  color: #999;
  text-indent: 5px;
  border: 1px solid #ddd;
  background: none;
  outline: none;
  margin: 0.6rem auto;
}
</style>
